import { TFunction } from '@lyearn/i18n';
import { DateValue } from '@/modules/corporate/modules/tags/types';
import { MultiSelectTagType, SingleSelectTagType, TagTypeEnum, TagUnion } from '@/types/schema';

import { DateValueTypeEnumSM, RelativeDateFilterOperatorEnumSM } from './types';

export const getTagOptions = (tag?: TagUnion | null) => {
  if (!tag) return [];

  if (tag.type === TagTypeEnum.MultiSelect || tag.type === TagTypeEnum.SingleSelect) {
    const multiSelectTag = tag as MultiSelectTagType | SingleSelectTagType;
    return multiSelectTag.options.map((option) => ({
      id: option.id,
      label: option.name,
    }));
  }

  return [];
};

export const isDateFilterEmpty = (value: DateValue, includeEndDate?: boolean) => {
  return !value?.startTime || (includeEndDate && !value?.endTime);
};

export const isDynamicDateFilterEmpty = (
  offsetDays?: number,
  offsetRelation?: RelativeDateFilterOperatorEnumSM,
) => {
  return offsetDays === undefined || !offsetRelation;
};

export const getDateValueTypeOptions = (t: TFunction) => [
  {
    id: DateValueTypeEnumSM.SpecificDate,
    label: t('Group:Editor.SpecificDate'),
  },
  {
    id: DateValueTypeEnumSM.Dynamic,
    label: t('Group:Editor.Dynamic'),
  },
];

export const getOffsetRelationOptions = (t: TFunction) => [
  {
    id: RelativeDateFilterOperatorEnumSM.Next,
    label: t('Group:Editor.InFuture'),
  },
  {
    id: RelativeDateFilterOperatorEnumSM.Previous,
    label: t('Group:Editor.InPast'),
  },
];

const MAPPED_TEXT_TO_TRANS: Record<string, string> = {
  [RelativeDateFilterOperatorEnumSM.Next]: 'Group:Editor.InTheFuture',
  [RelativeDateFilterOperatorEnumSM.Previous]: 'Group:Editor.InThePast',
};

export const getOffsetRelationi18Text = (
  t: TFunction,
  offsetRelation?: RelativeDateFilterOperatorEnumSM,
) => {
  if (!offsetRelation) {
    return '';
  }

  return t(MAPPED_TEXT_TO_TRANS[offsetRelation]);
};

export const INITIAL_DATE_FILTER_STATE = {
  dateValueType: DateValueTypeEnumSM.SpecificDate,
  offsetRelation: RelativeDateFilterOperatorEnumSM.Next,
  offsetDays: 0,
  tagValues: {
    startTime: undefined,
    endTime: undefined,
  },
};

const MAPPED_TEXT_TO_TRANS_PLACEHOLDER: Record<string, string> = {
  [RelativeDateFilterOperatorEnumSM.Next]: 'Group:Editor.InFuture',
  [RelativeDateFilterOperatorEnumSM.Previous]: 'Group:Editor.InPast',
};

export const getDynamicDateValuePlaceholder = (
  t: TFunction,
  offsetDays?: number,
  offsetRelation?: RelativeDateFilterOperatorEnumSM,
) => {
  if (offsetDays === undefined || !offsetRelation) {
    return '';
  }

  return t('Group:Editor.DynamicDateValuePlaceholder', {
    days: offsetDays,
    count: offsetDays,
    dimension: t(MAPPED_TEXT_TO_TRANS_PLACEHOLDER[offsetRelation]),
  });
};
